import { VerifiedCredentialRegistration } from "../../fabrix/services/modules/core/client-verified-credentials.service";

export const EMPLOYEE_CENTRE_MODULE_NAME = "employee-centre";
export const EMPLOYEE_CENTRE_CHALLENGE_LS_KEY = "employee-centre-credential-presented";
export const GOVERNMENT_EMPLOYEE_CREDENTIAL_NAME = "government employee";
export const INVOICE_APPROVER_CREDENTIAL_NAME = "invoice approver";

const INVALID_CREDENTIAL_STATES = new Set(["invalid", "revoked", "expired", "inactive"]);

const normalize = (value: unknown): string => {
  return String(value ?? "")
    .trim()
    .toLowerCase();
};

const credentialState = (registration: VerifiedCredentialRegistration): string => {
  const state = registration.data?.state ?? registration.data?.status;
  return normalize(state);
};

export const hasVerifiedCredential = (
  registrations: VerifiedCredentialRegistration[],
  credentialName: string
): boolean => {
  const normalizedCredentialName = normalize(credentialName);

  return registrations.some((registration) => {
    const definitionName = normalize(registration.definition?.name);
    if (definitionName !== normalizedCredentialName) {
      return false;
    }

    if (registration.definition?.active === false) {
      return false;
    }

    const state = credentialState(registration);
    return !INVALID_CREDENTIAL_STATES.has(state);
  });
};

export const hasGovernmentEmployeeCredential = (registrations: VerifiedCredentialRegistration[]): boolean => {
  return hasVerifiedCredential(registrations, GOVERNMENT_EMPLOYEE_CREDENTIAL_NAME);
};

export const hasInvoiceApproverCredential = (registrations: VerifiedCredentialRegistration[]): boolean => {
  return hasVerifiedCredential(registrations, INVOICE_APPROVER_CREDENTIAL_NAME);
};
